import { IconType } from '../Icons/HudIcons';

// TODO: Move to DTO
export type MetricId = string;

// We only support number rules for now (thresholds)
export enum ParameterType {
  Number = 'number',
}

// TODO: Move to DTO
export type ParameterDescriptor = {
  type: ParameterType;
  label: string;
  unit?: string;
  icon?: IconType;
  tooltip?: string;
  recommendation?: string;
  presetValues: number[];
};

// TODO: Move to DTO
export type SupportedDescriptors = Record<MetricId, ParameterDescriptor>;

// TODO: Move to DTO
export type DetectionParameter = {
  id: MetricId; // metric id must be present in descriptors
  value: number | null;
  operator: 'gte' | 'lte';
};
